import dayjs, { Dayjs } from 'dayjs';
import { AppointmentAthleteRetrieve } from 'types';

function getEventStartTime(appt: AppointmentAthleteRetrieve): Dayjs {
  const ts = Date.parse(`${appt.startDate}T${appt.startTime}`);
  return dayjs(ts);
}

function calculateWindowTime(eventStart: Dayjs, interval?: string, intervalCount?: number): Dayjs {
  if (!interval || intervalCount == null) return eventStart;
  return eventStart.subtract(intervalCount, interval as any);
}

export type UseAppointmentTiming = {
  eventStartDateTime: Dayjs;
  isWithinCancellationWindow: boolean;
  isWithinLateCancellationWindow: boolean;
};

export function useAppointmentTiming(
  appointment: AppointmentAthleteRetrieve | undefined,
): UseAppointmentTiming {
  const now = dayjs();

  if (!appointment) {
    return {
      eventStartDateTime: now,
      isWithinCancellationWindow: false,
      isWithinLateCancellationWindow: false,
    };
  }

  const eventStartDateTime = getEventStartTime(appointment);
  const settings = appointment.cancellationSettings;

  const cancellationDeadline = calculateWindowTime(
    eventStartDateTime,
    settings?.cancellationInterval,
    settings?.cancellationIntervalCount,
  );

  const isWithinCancellationWindow = now.isBefore(cancellationDeadline);

  const isWithinLateCancellationWindow = settings.allowLateCancellation
    ? now.isAfter(cancellationDeadline) && now.isBefore(eventStartDateTime)
    : false;

  return {
    eventStartDateTime,
    isWithinCancellationWindow,
    isWithinLateCancellationWindow,
  };
}
